/* eslint-disable react/prop-types */
import React from 'react';
import styled from 'styled-components';
import { SideNav, LogoBar, TopBar } from './inc/layouts';
import { Card, Avatar, Title, Breadcrumbs } from 'components/elements';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { logoutAction } from 'actions/auth';
import ProductList from './products/list';
import ProductNew from './products/new';
import CategoryList from './categories/list';
import CategoryNew from './categories/new';
import CertificateList from './certificates/list';
import CertificateNew from './certificates/new';
import HistoryList from './histories/list';
import HistoryNew from './histories/new';
import TimelineList from './timelines/list';
import TimelineNew from './timelines/new';
import FeatureItemList from './featureitems/list';
import FeatureItemNew from './featureitems/new';
import OptionList from './options/list';
import OptionEdit from './options/edit';
import ContactList from './contacts/list';
import ContactNew from './contacts/new';
import MessageList from './messages/list';
import MenuItemList from './menuitems/list';
import MenuItemNew from './menuitems/new';
import SlideshowItemList from './slideshowitems/list';
import SlideshowItemNew from './slideshowitems/new';

import PostList from './posts/list';
import PostNew from './posts/new';

const Dashboard = ({ className, auth, onLogout }) => {
  const cls = className;
  if (!auth.logged_in) {
    return <Redirect to="/auth/login/" />;
  }
  return (
    <div className={cls}>
      <div className={`${cls}__sidebar`}>
        <LogoBar />
        <SideNav onLogout={onLogout} />
      </div>
      <div className={`${cls}__main`}>
        <TopBar auth={auth} />
        <div className={`${cls}__main__content`}>
          <Switch>
            <Route exact path="/products/" component={ProductList} />
            <Route exact path="/products/new/" component={ProductNew} />
            <Route exact path="/products/:id/edit/" component={props => <ProductNew edit {...props} />} />

            <Route exact path="/categories/" component={CategoryList} />
            <Route exact path="/categories/new/" component={CategoryNew} />
            <Route exact path="/categories/:id/edit/" component={props => <CategoryNew edit {...props} />} />

            <Route exact path="/certificates/" component={CertificateList} />
            <Route exact path="/certificates/new/" component={CertificateNew} />
            <Route exact path="/certificates/:id/edit/" component={props => <CertificateNew edit {...props} />} />

            <Route exact path="/histories/" component={HistoryList} />
            <Route exact path="/histories/new/" component={HistoryNew} />
            <Route exact path="/histories/:id/edit/" component={props => <HistoryNew edit {...props} />} />

            <Route exact path="/timelines/" component={TimelineList} />
            <Route exact path="/timelines/new/" component={TimelineNew} />
            <Route exact path="/timelines/:id/edit/" component={props => <TimelineNew edit {...props} />} />
			
			<Route exact path="/featureitems/" component={FeatureItemList} />
            <Route exact path="/featureitems/new/" component={FeatureItemNew} />
            <Route exact path="/featureitems/:id/edit/" component={props => <FeatureItemNew edit {...props} />} />

			<Route exact path="/menuitems/" component={MenuItemList} />
            <Route exact path="/menuitems/new/" component={MenuItemNew} />
            <Route exact path="/menuitems/:id/edit/" component={props => <MenuItemNew edit {...props} />} />

			<Route exact path="/slideshowitems/" component={SlideshowItemList} />
            <Route exact path="/slideshowitems/new/" component={SlideshowItemNew} />
            <Route exact path="/slideshowitems/:id/edit/" component={props => <SlideshowItemNew edit {...props} />} />

			<Route exact path="/posts/" component={PostList} />
            <Route exact path="/posts/new/" component={PostNew} />
            <Route exact path="/posts/:id/edit/" component={props => <PostNew edit {...props} />} />
			
            <Route exact path="/messages/" component={MessageList} />

            <Route exact path="/options/" component={OptionList} />
            <Route exact path="/options/:id/edit/" component={props => <OptionEdit edit {...props} />} />

            <Route exact path="/contacts/" component={ContactList} />
            <Route exact path="/contacts/new/" component={ContactNew} />
            <Route exact path="/contacts/:id/edit/" component={props => <ContactNew edit {...props} />} />
          </Switch>
        </div>
      </div>
    </div>
  );
};
const StyledDashboard = styled(Dashboard)`
  display: flex;
  &__sidebar{
    width: 200px;
    background-color: #fff;
    height: 100vh;
    border-left: 1px solid rgba(0,0, 0, .06);
    box-shadow: 0px 0 15px rgba(0, 0, 0, .05);
    z-index: 4;
  }
  &__main{
    background-color: rgba(0, 0, 0, .06);
    flex: 1;
    &__content{
      padding: 25px;
      height: calc( 100vh - 65px );
      overflow: auto;
      &::-webkit-scrollbar {
        width: 5px;
      }

      /* Track */
      &::-webkit-scrollbar-track {
        background: #f1f1f1;
      }

      /* Handle */
      &::-webkit-scrollbar-thumb {
        background: #888;
      }

      /* Handle on hover */
      &::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
    }
  }
`;

const mapStateToProps = (state) => ({
  auth: state.auth,
});
const mapDispatchToProps = (dispatch) => ({
  onLogout: () => dispatch(logoutAction()),
});
export default connect(mapStateToProps, mapDispatchToProps)(StyledDashboard);